import { Button, Flex, Pane, TableV2, Text } from '@leverege/ui-elements'
import { Parser } from 'json2csv'
import React, { useCallback } from 'react'
import fields from '../helpers/exportableFields'
import useAlertsTable from '../hooks/useAlertsTable'

import S from './AlertsTable.css'

export default function AlertsTable( props ) {
  const { className } = props
  const { data, columns } = useAlertsTable( props )

  const handleDownloadCsv = useCallback( () => {
    const opts = { fields }
    const parser = new Parser( opts )
    const csv = parser.parse( data )
    const file = new Blob( [ csv ], { type : 'export.csv' } );
    if ( window.navigator.msSaveOrOpenBlob ) {
      window.navigator.msSaveOrOpenBlob( file, 'export.csv' )
    } else {
      // Others
      const a = document.createElement( 'a' ),
        url = URL.createObjectURL( file )
      a.href = url
      a.download = 'export.csv'
      document.body.appendChild( a )
      a.click()
      setTimeout( () => {
        document.body.removeChild( a )
        window.URL.revokeObjectURL( url )
      }, 0 )
    }
  }, [ data ] )

  return (
    <Pane variant="cardNoPad" layout="flex:col" className={className}>
      <div
        style={{
          height : '60px',
          padding : 'var(--size-padLarge)',
          borderBottom : '1px solid var(--color-base100)',
        }}>
        <Flex variant="rowSpaceBetween">
          <Text variant="subtitle">All Alerts</Text>
          <Flex variant="rowMCenter">
            <Button
              onClick={handleDownloadCsv}
              icon="fa-regular fa-download"
              variant="downloadButton"/>
          </Flex>
        </Flex>
      </div>
      <div
        style={{
          height : 'calc(100% - 60px)',
        }}>
        <TableV2
          type="virtualized"
          className={S.table}
          variant="traffic"
          data={data}
          columns={columns}/>
      </div>
    </Pane>
  )
}
